import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../config/config";
import { Container, Row, Col, Nav, Tab } from "react-bootstrap";
import Dashboardheader from "../directives/dashboardheader";
import {
  DepositWithdrwalHistory,
  walletStatisticsAction,
  adressUpdateAction,
  handleVestingWalletDataHistory,
  UserProfile,
} from "../Action/user.action";
import toast, { Toaster } from "react-hot-toast";
import ReactPaginate from "react-paginate";
import Cookies from "js-cookie";
import Passbook from "./Passbook/Passbook";
import { Alert, Switch } from "@mui/material";
import { FormControlLabel } from "@material-ui/core";
import Swal from "sweetalert2";
import Web3 from "web3";
import { useDispatch, useSelector } from "react-redux";
import { setStepwalletReducers } from "../redux/slicess/StepwalletSlice";
import WalletModal from "./Modals/walletSelectModal";
import { Spinner } from "react-bootstrap";

import { ShimmerSimpleGallery } from "react-shimmer-effects";
import ContentLoader from "react-content-loader";
import Dashboardsubheader from "../directives/dashboardsubheader";

const Wallethistory = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const loginData = !Cookies.get("loginSuccessStepMrMint", {
    domain: "mrmint.io",
  })
    ? []
    : JSON.parse(
        Cookies.get("loginSuccessStepMrMint", { domain: "mrmint.io" })
      );
  const [wallethistorydata, setwallethistorydata] = useState({});
  const [activeTab, setActiveTab] = useState("withdrawrequest");
  const [viewbalance, setviewbalance] = useState(false);
  const [withdrawType, setWithdrawType] = useState(3);
  const [wallethistorydatalist, setwallethistorydatalist] = useState([]);
  const [refWallethistoryDatalist, setRefWallethistoryDatalist] = useState([]);
  const [vestingWalletHistoryDataList, setVestingWalletHistoryDataList] =
    useState([]);
  const [page, setPage] = useState(1);
  const stepWalletData = useSelector(
    (state) => state.Stepwallet.stepWalletData
  ); //this is for redux dont remove this line
  const [paginationStatus, setpaginationStatus] = useState(false);
  const [userData, setUserData] = useState(null);
  const [activeTabing, setActiveTabing] = useState(3);
  const [loding, setloding] = useState(false);

  const dispatch = useDispatch(); //this is for redux dont remove this line

  const itemsPerPage = 10; // Set the number of items per page
  const [currentPage, setCurrentPage] = useState(0);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };
  const CurrentPageResetFunc = () => {
    setCurrentPage(0);
    handlePageChange({ selected: 0 });
  };
  // Handle view balance click
  const handleViewBalance = () => {
    setviewbalance(!viewbalance);
  };

  useEffect(() => {
    wallethistory();
    wallethistorylist();
    getUserProfile();
  }, [withdrawType, page]);

  const wallethistory = async () => {
    let res2 = await walletStatisticsAction();

    if (res2.success) {
      setwallethistorydata(res2.data);
    } else {
      setwallethistorydata([]);
    }
  };

  const wallethistorylist = async () => {
    setloding(true);
    try {
      let data = {
        page: page,
        limit: 10,
        withdraw_type: withdrawType,
      };
      let res = await DepositWithdrwalHistory(data);
      if (res.success) {
        setloding(false);
        if (res.data.history.length == 0) {
          setpaginationStatus(true);
        }
        if (withdrawType == 3) {
          setwallethistorydatalist((prevData) => [
            ...prevData,
            ...res.data.history,
          ]);
        } else {
          setRefWallethistoryDatalist((prevData) => [
            ...prevData,
            ...res.data.history,
          ]);
        }
      } else {
        setloding(false);
        setwallethistorydatalist([]);
      }
    } catch (error) {
      setloding(false);
      console.log(error);
    }
  };

  // --------------------------------------------------------Email verification Modal code-----------------------------------------

  const handleEmailVerificationModal = async (e) => {
    // setshowModal(true);
    Swal.fire({
      title: `Email Verification Required`,
      html: "Please verify your email address to continue. <br/> <b>Important</b>: Once your email is verified, it cannot be changed later. <br/> Thank you for your cooperation!",
      confirmButtonColor: "#3085d6",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Verify!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        navigate(`${config.baseUrl}profile`);
      }
    });
  };
  const handleWalleteVerificationModal = async (e) => {
    // e.preventDefault();
    const result = await Swal.fire({
      title: "Final Wallet Address",
      html: "This can’t be changed later. Verify before saving.",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      customClass: {
        popup: "custum_background wallet_card", // multiple classes here
      },
    });
    if (!result.isConfirmed) {
      return;
    }
    connectMetasmaskForAddress();
  };

  const handleWithdrawlAction = (e) => {
    if (userData) {
      if (userData.is_email_verify == 0) {
        handleEmailVerificationModal(e);
        return;
      }

      if (!userData.bnb_address == null) {
        handleWalleteVerificationModal(e);
        return;
      }

      if (userData.country_name === null) {
        alert("Please select country first from mobile app!");
        return;
      }
      handleShow();
    }
  };

  const handleReferralWithdrawlAction = (e) => {
    navigate(`${config.baseUrl}referralwallet`);
  };
  const handleStakingAction = (e) => {
    navigate(`${config.baseUrl}staking`);
  };
  const handleBusinessWalletTransferAction = (e) => {
    navigate(`${config.baseUrl}businesswallettransfer`);
  };

  const handleWalletWithdrawl = (e) => {
    navigate(`${config.baseUrl}withdraw`);
  };

  const connectMetasmaskForAddress = async (e) => {
    try {
      if (window.ethereum) {
        var web3 = new Web3(window.ethereum);
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        console.log(accounts, "///", window.ethereum);
        let chainId = await web3.currentProvider.chainId;
        if (!chainId) {
          chainId = web3.currentProvider.getChainId();
        }
        if (
          chainId != config.chainId &&
          web3.utils.toHex(parseInt(chainId)) != config.chainId
        ) {
          toast.error(`Please select BNB smartchain!!`);

          return false;
        } else {
          console.log(accounts[0]);
          if (accounts[0]) {
            let publicAddress = accounts[0];
            const { signature } = await new Promise((resolve, reject) =>
              web3.eth.personal.sign(
                web3.utils.fromUtf8(`Login Mrmint`),
                publicAddress,
                (err, signature) => {
                  if (err) return reject(err);
                  return resolve({ publicAddress, signature });
                }
              )
            );
            let res = await adressUpdateAction({
              bnb_address: accounts[0],
            });
            console.log("test3");
            if (res.success) {
              loginData.bnb_address = accounts[0];
              Cookies.set("loginSuccessStepMrMint", JSON.stringify(loginData));
              window.location.href = `${config.baseUrl}wallethistory`;
              toast.success(res.msg);
            } else {
              toast.error(res.msg);
            }
          }
        }
      } else {
        toast.error("Please use Dapp browser!!");
      }
    } catch (error) {
      console.log("error", error);

      switch (error.code) {
        case 4001: // User rejected the request
          toast.error("User rejected the request.");
          break;
        case -32002: // Request already in progress
          toast.error(
            "Request already in progress. Please check your MetaMask wallet."
          );
          break;
        case "ERR_NETWORK": // Network issues
          toast.error("Network error. Please try again.");
          break;
        default:
          toast.error("An unexpected error occurred.");
          break;
      }
    }
  };

  // api for vesting wallet data ====================
  const handleVestingWalletData = async () => {
    setActiveTabing(1);
    setWithdrawType("");
    try {
      let data = {
        page: 1,
        limit: 10,
      };
      let res = await handleVestingWalletDataHistory(data);
      if (res.success) {
        setVestingWalletHistoryDataList(res.data.history);
      } else {
        setVestingWalletHistoryDataList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getUserProfile = async () => {
    let res = await UserProfile();
    if (res.success) {
      setUserData(res.data);
    } else {
      setUserData([]);
    }
  };
  const handleLoadMore = () => {
    setPage(page + 1);
  };

  // this code for handle tab change

  const handleTabChange = (id) => {
    if (activeTabing !== id) {
      // Prevents unnecessary state updates on double click
      setActiveTabing(id);
      setWithdrawType(id);
      setwallethistorydatalist([]);
      setRefWallethistoryDatalist([]);
      setpaginationStatus(false);
      setPage(1);
    }
  };

  const handleVestingWithdrawlAction = () => {
    navigate(`${config.baseUrl}vestingWallateHistory`);
  };
  // dynamic tabing  section data

  const ShimmerLoader = () => (
    <Row>
      {Array(3)
        .fill(0)
        .map((_, index) => (
          <Col xs={12} className="mb-3" key={index}>
            <ContentLoader
              speed={1.5}
              width="100%"
              height={80}
              viewBox="0 0 400 80" // Virtual coordinate system
              backgroundColor="#2a2a2a"
              foregroundColor="#3d3d3d"
              preserveAspectRatio="none" // This allows the rect to stretch fully
              style={{ width: "100%", height: "80px" }} // This is the real size
            >
              <rect x="0" y="0" rx="10" ry="10" width="400" height="80" />
            </ContentLoader>
          </Col>
        ))}
    </Row>
  );

  const TabContent = ({ eventKey, data, type }) => {
    return (
      <Tab.Pane eventKey={eventKey}>
        <Row className="gy-3 sofia-sans">
          {loding ? (
            <div
              className="text-center w-100 d-flex justify-content-center align-items-center"
              // style={{ height: "80vh" }}
            >
              <ShimmerLoader />
            </div>
          ) : data.length > 0 ? (
            <>
              {type === "vesting" ? (
                <>
                  {data.map((item, index) => (
                    <Col xl={4} lg={6} key={index}>
                      <div
                        style={{
                          backgroundColor: "#151515",
                          borderRadius: 10,
                          textTransform: "capitalize",
                        }}
                      >
                        <div
                          className="wallet-card-div text-white px-3 py-2 fs14 sofia-sans"
                          style={{ borderRadius: "10px 10px 0px 0px" }}
                        >
                          Transfer
                        </div>
                        <Row className="gy-2 px-3 pt-3 sofia-sans">
                          <Col lg={4} md={4} sm={4} xs={4}>
                            <p className="text-secondary wcard-title mb-2">
                              Date
                            </p>
                            <p className="wcard-data">{item.transfer_date}</p>
                          </Col>

                          <Col
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            className="text-center"
                          >
                            <p className="text-secondary wcard-title mb-2">
                              Amount
                            </p>
                            <p className="wcard-data">{item.amount}</p>
                          </Col>
                          <Col lg={4} md={4} sm={4} xs={4} className="text-end">
                            <p className="text-secondary wcard-title mb-2">
                              Status
                            </p>
                            <p className="text-success wcard-data">Success</p>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  ))}
                </>
              ) : (
                <>
                  {data.map((item, index) => (
                    <Col xl={12} key={index}>
                      <div
                        style={{
                          backgroundColor: "#151515",
                          borderRadius: 10,
                          textTransform: "capitalize",
                        }}
                      >
                        <div
                          className="wallet-card-div text-secondary px-3 py-2 fs14"
                          style={{ borderRadius: "10px 10px 0px 0px" }}
                        >
                          Type:{" "}
                          <span className="text-white">
                            {item.type || type}
                          </span>
                        </div>
                        <Row className="gy-2 px-3 pt-3">
                          <Col className="text-center">
                            <p className="text-secondary wcard-title mb-2">
                              Requested Date
                            </p>
                            <p className="wcard-data">
                              {item.requested_date || item.requestedDate}
                            </p>
                          </Col>

                          <Col className="text-center">
                            <p className="text-secondary wcard-title mb-2">
                              Requested Time
                            </p>
                            <p className="wcard-data">
                              {item.requested_time || item.requestedTime}
                            </p>
                          </Col>
                          <Col className="text-center">
                            <p className="text-secondary wcard-title mb-2">
                              {item.status === "Rejected"
                                ? "Rejected Date"
                                : "Approved Date"}
                            </p>
                            <p className="wcard-data">{item.approved_date}</p>
                          </Col>

                          <Col className="text-center">
                            <p className="text-secondary wcard-title mb-2">
                              {item.status === "Rejected"
                                ? "Rejected Time"
                                : "Approved Time"}
                            </p>
                            <p className="wcard-data">{item.approved_time}</p>
                          </Col>
                          <Col className="text-center">
                            <p className="text-secondary wcard-title mb-2">
                              Amount
                            </p>
                            <p
                              style={{ fontWeight: 700 }}
                              className={` ${
                                item.status === "Pending"
                                  ? "text-warning"
                                  : item.status === "Rejected"
                                  ? "text-danger"
                                  : "text-success"
                              } wcard-data`}
                            >
                              {item.usd_amount || item.amount} MNT
                            </p>
                          </Col>
                          <Col className="text-center">
                            <p className="text-secondary wcard-title mb-2">
                              Status
                            </p>
                            <p
                              className={` ${
                                item.status === "Pending"
                                  ? "text-warning"
                                  : item.status === "Rejected"
                                  ? "text-danger"
                                  : "text-success"
                              } wcard-data`}
                            >
                              {item.status}
                            </p>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  ))}
                </>
              )}
            </>
          ) : (
            <div
              className="text-center d-flex justify-content-center align-items-center flex-column"
              style={{
                padding: "20px",
                color: "#d3d3d3",
                borderRadius: "8px",
                // height: "80vh",
              }}
            >
              <img
                style={{ width: "auto", height: "auto" }}
                 src="assets\images\newdesign\nodata-new.png"
                width={120}
                className="mb-4"
                alt="No Data"
              />
              <h4 className="text-white">No data found</h4>
            </div>
          )}
        </Row>
      </Tab.Pane>
    );
  };

  return (
    <>
      <Dashboardheader />
      <Toaster />
      <div className="position-relative">
        <div className="db1"></div>
        {/* <div className="db2"></div> */}
        {/* <div className="db3"></div> */}
        <div className="db4"></div>
        <div className="db5"></div>
        <div className="db6"></div>
        <div className="db7"></div>
        <div className="db8"></div>

        <div className="shape_bg">
          <img src="assets/images/shape2.svg" className="shape2" alt="" />
        </div>
        <div className="page-wrapper">
          <div className="position-relative overflow-hidden mt-5 pt-2 mb-5">
            <div className="mb-4">
              <Container className="">
                <Row className="align-items-center">
                  <Col lg={9}>
                    <h2 className="text-white sofia-sans" style={{ fontWeight: 600 }}>
                      Wallet Overview
                    </h2>
                  </Col>
                </Row>
              </Container>
            </div>
            {/* ---------- */}

            <div className="">
              <Container>
                <Row>
                  <Col lg={5} md={12} className="mb-3">
                    <div className="wallet_card">
                      <div className="card-view3 p-4">
                        <div className="d-flex justify-content-between align-items-center">
                          <h4 className="text-light-grey mb-3 sofia-sans" >
                            Total Balance
                          </h4>

                          <div
                            className="mb-3"
                            onClick={(e) => e.stopPropagation()} // Stop clicks from bubbling
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={viewbalance}
                                  onChange={(e) => {
                                    e.stopPropagation(); // Make sure switch change doesn't bubble
                                    handleViewBalance(e);
                                  }}
                                />
                              }
                              label={
                                <span style={{ fontSize: 10, color: "white" }}>
                                  {viewbalance ? "Hide" : "Show"}
                                </span>
                              }
                              style={{ color: "white" }}
                            />
                          </div>
                        </div>

                        <div>
                          <span>
                            <img
                              src="assets/images/mntcoin.png"
                              width="20px"
                              alt="MNT"
                            />
                            &nbsp;
                            {viewbalance
                              ? wallethistorydata.total_balance > 0
                                ? wallethistorydata.total_balance
                                : 0
                              : "********"}{" "}
                            MNT
                          </span>
                        </div>

                        {/* Action Button */}
                        <div className="w-btn-list justify-content-between gap-2 flex-wrap mt-4 h-100">
                          <div>
                            <button
                              type="button"
                              className="w-btn card-view w-100"
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent bubbling
                                handleWithdrawlAction();
                              }}
                            >
                              <div style={{ position: "relative" }}>
                                {/* <img
                      src="assets/images/walletback1.svg"
                      style={{
                        position: "absolute",
                        right: 0,
                        opacity: 0.5,
                        top: 0,
                        zIndex: 0,
                      }}
                      alt=""
                    />
                    <img
                      src="assets/images/walletback2.svg"
                      style={{
                        position: "absolute",
                        left: 0,
                        top: 0,
                        opacity: 0.5,
                      }}
                      alt=""
                    /> */}
                                <img
                                  src="assets/images/wallet02.png"
                                  alt=""
                                  style={{ width: 35, height: 35 }}
                                />
                                &nbsp;&nbsp;<small>Wallets</small>
                              </div>
                            </button>
                          </div>
                        </div>

                        <div className="chart_icon" style={{ zIndex: -1 }}>
                          <img src="assets/images/chart_wave.png" alt="" />
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col lg={1} className="mb-3" />

                  <Col
                    lg={6}
                    style={{
                      fontSize: "14px",
                      marginTop: "2.5px",
                      whiteSpace: "normal",
                    }}
                  >
                    <h3 style={{ color: "white" }} className="mb-0 sofia-sans">
                      Terms and Condition:
                    </h3>
                    {/* <p>{wallethistorydata.termsCondition}</p> */}
                    <p
                      className="mb-0 sofia-sans" style={{fontSize:14}}
                      dangerouslySetInnerHTML={{
                        __html: wallethistorydata.termsCondition,
                      }}
                    />
                  </Col>
                </Row>
              </Container>
            </div>

            {/* ---------- */}

            <div className="transaction mb-5">
              <Container>
                <h2 className="text-white mb-4 sofia-sans" style={{ fontWeight: 600 }}>
                  Statistics
                </h2>
                <div className="transaction_detail">
                  <Row className="sofia-sans">
                    <Col className="mb-4 d-flex">
                      <div className="listbox flex-fill d-flex align-items-center justify-content-center w-100 ">
                        <div className="d-flex flex-column gap-2">
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.stepReward}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p className="mb-0 text-center fs14 sofia-sans">Step Rewards</p>
                        </div>
                      </div>
                    </Col>
                    <Col className="mb-4 d-flex ">
                      <div className="listbox flex-fill d-flex align-items-center justify-content-center w-100 ">
                        <div className="d-flex flex-column gap-2">
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.referralAmount}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p className="mb-0 text-center fs14 sofia-sans">
                            Referral Rewards
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col className="mb-4 d-flex">
                      <div className="listbox flex-fill d-flex align-items-center justify-content-center w-100 ">
                        <div className="d-flex flex-column gap-2">
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.matchingAmount}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p className="mb-0 text-center fs14 sofia-sans">
                            Community Rewards
                          </p>
                        </div>
                      </div>
                    </Col>

                    <Col className="mb-4 d-flex r">
                      <div className="listbox flex-fill d-flex align-items-center justify-content-center w-100 ">
                        <div className="d-flex flex-column gap-2">
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.loyalty_earning}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p className="mb-0 text-center fs14 sofia-sans">
                            Walker Loyalty Rewards
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col className="mb-4 d-flex r">
                      <div className="listbox flex-fill ">
                        <div className="d-flex flex-column gap-2">
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.total_withdraw}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p className="mb-0 text-center fs14 sofia-sans">Total Withdrawn</p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Container>
            </div>

            {/* ---------- */}
            <div className="latest_transaction mb-5">
              <Container>
                <Tab.Container
                  id="left-tabs-example"
                  defaultActiveKey="stepwallet"
                  onSelect={(key) => setActiveTab(key)}
                >
                  <h2 className="text-white mb-4 sofia-sans" style={{ fontWeight: 600 }}>
                    Wallet History
                  </h2>
                  <Nav variant="pills" className=" text-center ">
                    <Row className="w-100 text-center mb-4">
                      <Col lg={4} sm={6}>
                        <Nav.Item>
                          <Nav.Link
                            onClick={() => handleTabChange(3)}
                            eventKey="stepwallet"
                            className="card-view1 customnav-link px-0"
                          >
                            StepMint Wallet
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                      <Col lg={4} sm={6}>
                        <Nav.Item>
                          <Nav.Link
                            onClick={() => handleTabChange(4)}
                            eventKey="referralwallet"
                            className="card-view1 customnav-link px-0"
                          >
                            Business Wallet
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                      <Col lg={4} sm={6}>
                        <Nav.Item>
                          <Nav.Link
                            onClick={handleVestingWalletData}
                            eventKey="vestingwallet"
                            className="card-view1 customnav-link px-0"
                          >
                            Vesting Wallet
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                    </Row>
                  </Nav>
                  <Tab.Content>
                    <TabContent
                      eventKey="stepwallet"
                      data={wallethistorydatalist}
                    />
                    <TabContent
                      eventKey="referralwallet"
                      data={refWallethistoryDatalist}
                    />
                    <TabContent
                      eventKey="vestingwallet"
                      data={vestingWalletHistoryDataList}
                      type="vesting"
                    />
                    <Tab.Pane eventKey="passbook">
                      {activeTab === "passbook" && <Passbook />}
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Container>
            </div>

            {activeTabing == 3 &&
              wallethistorydatalist.length >= 10 &&
              !loding && (
                <>
                  {!paginationStatus && (
                    <center onClick={handleLoadMore}>
                      <div
                        className="gap-2 py-3 joined-user"
                        style={{
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "black",
                          width: 180,
                          borderRadius: 8,
                        }}
                      >
                        <div className="ani-container">
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                        </div>
                        <div style={{ fontWeight: 500 }}>Load More</div>
                      </div>
                    </center>
                  )}
                </>
              )}
            {activeTabing == 4 &&
              refWallethistoryDatalist.length >= 10 &&
              !loding && (
                <>
                  {!paginationStatus && (
                    <center onClick={handleLoadMore}>
                      <div
                        className="gap-2 py-3 joined-user"
                        style={{
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "black",
                          width: 180,
                          borderRadius: 8,
                        }}
                      >
                        <div className="ani-container">
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                        </div>
                        <div style={{ fontWeight: 500 }}>Load More</div>
                      </div>
                    </center>
                  )}
                </>
              )}
            {activeTabing == 1 &&
              vestingWalletHistoryDataList.length >= 10 &&
              !loding && (
                <>
                  {!paginationStatus && (
                    <center onClick={handleLoadMore}>
                      <div
                        className="gap-2 py-3 joined-user"
                        style={{
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "black",
                          width: 180,
                          borderRadius: 8,
                        }}
                      >
                        <div className="ani-container">
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                        </div>
                        <div style={{ fontWeight: 500 }}>Load More</div>
                      </div>
                    </center>
                  )}
                </>
              )}
          </div>
        </div>
        {show && (
          <WalletModal
            show={show}
            handleClose={handleClose}
            userData={userData}
            handleWalletWithdrawl={handleWalletWithdrawl}
            handleVestingWithdrawlAction={handleVestingWithdrawlAction}
            handleReferralWithdrawlAction={handleReferralWithdrawlAction}
            handleStakingAction={handleStakingAction}
            handleBusinessWalletTransferAction={
              handleBusinessWalletTransferAction
            }
          />
        )}
      </div>
    </>
  );
};
export default Wallethistory;
